import { LOCATION } from 'store/types'
import { locationConnector } from 'shared/connectors'
import { showPreloader, hidePreloader } from 'store/actions/viewManagement'
import { getSelectedRow } from 'store/selectors/viewManagementSelector'
import { updateSelectedRow } from '../viewManagement'

const success = () => ({
  type: LOCATION.EDIT_LOCATION_SUCCESS,
})

const editLocation = locationData => async (dispatch, getState) => {
  try {
    dispatch(showPreloader())

    const { error = false } = getSelectedRow(getState())
    await locationConnector.editLocation(locationData, error)

    dispatch(success())
    dispatch(hidePreloader())
    return true
  } catch ({ response: { data } }) {
    dispatch(updateSelectedRow(data))
    dispatch(hidePreloader())
    return false
  }
}

export default editLocation
